import {
  ADD_BEHAVIORS,
  ADD_PRISMIC_CONTENT,
  CmsActionsTypes,
  REMOVE_BEHAVIOR,
  REMOVE_BEHAVIORS,
  START_LOADING,
  STOP_LOADING,
  SHOW_SPINNER,
  HIDE_SPINNER,
  LOAD_AVATAR,
  SET_IS_MOBILE
} from './cms-actions';
import { CmsState, initialState } from './cms-state';
import update from 'immutability-helper';

export default (state: CmsState = initialState, action: CmsActionsTypes): CmsState => {
  switch (action.type) {
    case START_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case STOP_LOADING:
      return {
        ...state,
        isLoading: false,
      };
    case SHOW_SPINNER:
      return {
        ...state,
        isShowSpinner: true,
      };
    case HIDE_SPINNER:
      return {
        ...state,
        isShowSpinner: false,
      };
    case ADD_PRISMIC_CONTENT:
      return {
        ...state,
        cmsContent: {
          ...state.cmsContent,
          [action.payload.stepId]: { ...state.cmsContent[action.payload.stepId], ['prismic']: action.payload.prismic },
        },
      };
    case ADD_BEHAVIORS:
      return {
        ...state,
        cmsContent: {
          ...state.cmsContent,
          [action.payload.stepId]: { ...state.cmsContent[action.payload.stepId], ['behaviors']: action.payload.behaviors },
        },
      };

    case REMOVE_BEHAVIOR: {
      return update(state, { cmsContent: { [action.payload.stepId]: { behaviors: { $unset: [action.payload.behaviorKey] } } } });
    }
    case REMOVE_BEHAVIORS: {
      return update(state, { cmsContent: { [action.payload.stepId]: { $unset: ['behaviors'] } } });
    }
    case SET_IS_MOBILE:
      return {
        ...state,
        isMobile: action.payload,
      };
    case LOAD_AVATAR:
      return {
        ...state,
        avatar: action.payload
      }
    default:
      return state;
  }
};
